var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"main-form__login-email-a mb-0",attrs:{"href":_vm.url+'?email='+_vm.email.replace('+', '%2b')}},[_vm._v("\n    CONTINUE\n")])}
var staticRenderFns = []

export { render, staticRenderFns }